module.exports = __webpack_public_path__ + "img/61.0ab9a4e5.0ab9a4e5.svg";